import { setPauseButton } from "..";
import { pushVideoEvent, VIDEO } from "../events";

// html5
export function damPlayer(damVideo) {
    let eventsPushed = {};

    setPauseButton(damVideo.parentElement);

    damVideo.addEventListener("loadedmetadata", function (e) {
        if (damVideo.closest(".tns-slide-cloned")) { // to avoid duplicate "view" push, due to carousel cloning of slides
            eventsPushed[VIDEO.loaded] = true;
        } else {
            if (!eventsPushed[VIDEO.loaded]) {
                pushVideoEvent({
                    event: VIDEO.loaded,
                    event_type: "load",
                    video_duration: e.target.duration,
                    video_provider: "dam",
                    video_percent: "0%",
                });

                eventsPushed[VIDEO.loaded] = true;
            }
        }
    });

    if (!eventsPushed[VIDEO.loaded]) {
        damVideo.load();
    }
    
    damVideo.addEventListener("playing", function (e) {
        if (!eventsPushed[VIDEO.start] && !isNaN(e.target.duration)) {
            pushVideoEvent({
                event: VIDEO.start,
                event_type: "start",
                video_duration: e.target.duration,
                video_provider: "dam",
                video_percent: "0%",
            });

            eventsPushed[VIDEO.start] = true;
        }
    });

    damVideo.addEventListener("pause", function (e) {
        const currentTime = e.target.currentTime;
        const duration = e.target.duration;
        const pct = Math.floor((currentTime / duration) * 100);
        pushVideoEvent({
            event: VIDEO.progress(pct),
            event_type: "progress",
            video_duration: duration,
            video_percent: `${pct}%`,
            video_provider: "dam",
        });
    });

    damVideo.addEventListener("timeupdate", e => {
        let pct = (e.target.currentTime / e.target.duration) * 100;
        let pctCeil = Math.ceil(pct);
        if (pct >= 10 && pctCeil % 10 === 0) {
            if (!eventsPushed[pctCeil]) {
                eventsPushed[pctCeil] = true;
                pushVideoEvent({
                    event: VIDEO.progress(pctCeil),
                    event_type: "progress",
                    video_duration: e.target.duration,
                    video_provider: "dam",
                    video_percent: `${pctCeil}%`
                });
            }
        }
    });

    // Ended
    damVideo.addEventListener("ended", function (e) {
        eventsPushed = {};
        pushVideoEvent({
            event: VIDEO.complete,
            event_type: "complete",
            video_duration: e.target.duration,
            video_provider: "dam",
            video_percent: "100%"
        });
    });

    // Error
    damVideo.addEventListener("error", function (e) {
        let error = e;

        // Chrome v60
        if (e.path && e.path[0]) {
            error = e.path[0].error;
        }

        // Firefox v55
        if (e.originalTarget) {
            error = error.originalTarget.error;
        }

        if (!eventsPushed[VIDEO.error]) {
            pushVideoEvent({
                event: VIDEO.error,
                event_type: "error",
                video_duration: error.originalTarget.duration ?? 0,
                video_provider: "dam",
                video_percent: "0%"
            });

            eventsPushed[VIDEO.error] = true;
        }
    });
}
